module.exports = __webpack_public_path__ + "static/media/menu-mob.d8b0919f.svg";